import { IPagePath, IUpdateInterLinkDTO } from '@/models/linkingTool.model';
import { LinkingFormFields, TUpdateLinkingTemplateFormValues } from '../helpers';

class UpdateInterLinkDTO implements IUpdateInterLinkDTO {
  pagePath?: string;

  id: string;

  links?: IPagePath[];

  constructor(values: TUpdateLinkingTemplateFormValues & { id: string }) {
    this.pagePath = decodeURIComponent(decodeURIComponent(values[LinkingFormFields.PAGE_PATH]));

    this.links = values[LinkingFormFields.LINKS];

    this.id = values.id;
  }
}

export default UpdateInterLinkDTO;
